<template>
    <div class="detail-shop-brief touch-strip" v-if="shopData" @click="goShop()">
        <div class="content">
            <img v-lazy="replaceProtocol(shopData.shopLogoUrl)" width="81" height="50">
            <div class="shop-item">
                <span class="name" v-if="shopData.shopName">{{shopData.shopName}}</span>
                <img src="../../assets/allow.png" class="allow" @click="goLicense">
            </div>
            <span class="more">进入店铺</span>
        </div>        
        <i class="arrow"></i>
        <div class="announcement" v-if="announcement">{{announcement}}</div>
    </div>
</template>

<script>
import { isIOS11App } from '@/business/global';
export default {
    name: 'shopBrief',
    data() {
        return {
        }
    },
    props: {
        prdTmpId: {
            type: Number,
            default: function () {
                return 5
            }
        },
        shopData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        isApp: {
            type: Boolean,
            default: function () {
                return false
            }
        }, 
        agencyType: {
            type: Number,
            default: function () {
                return 1
            }
        },
    },
    computed: {
        announcement () {
            return this.agencyType === 0 ? '本产品由零售商直售并提供服务' : '';
        }
    },
    methods: {
        goShop () {
            if (this.shopData && this.shopData.shopMUrl) {
                window.location.href = this.isApp && isIOS11App() ? `tuniuapp://page?iosPageName=TNReactNativeViewController&androidPageName=com.tuniu.app.ui.activity.TNReactNativeActivity&parameters={"rctModule":"tnmall","rctModuleName":"mallShopRoutes","rctModuleParams":{"shopId":` + (this.shopData && this.shopData.shopId) + `}}` : this.shopData.shopMUrl;
            }
        },
        goLicense(e) {
            e.preventDefault();
            e.stopPropagation();
            location.href = this.getAppLink('/license/' + (this.shopData && this.shopData.shopId));
        },
        replaceProtocol(url) {
            return url ? url.replace(/^http:/g, 'https:') : "";
        }
    }
}
</script>

<style lang="scss">
@import '../style/common.scss';

.detail-shop-brief  {
    background: #fff;
    margin: 9px 0;
    padding: 18px 0 0;
    overflow: hidden;
    border-radius: $borderBigRadius;
    .content {
        padding-bottom: 12px;
    }
    .content > img {
        display: block;
    }
    .shop-item{
        position: absolute;
        width: 100%;
        height: 50px;
        top: 20px;
        left: 0;
        box-sizing: border-box;
        padding: 0 90px 0 105px;
        overflow: hidden;
        line-height: 24px;
        .name {
            display: inline-block;
            width: 100%;
            font-size: 16px;
            font-weight: 700;
            color: $fontStrongColor;
            letter-spacing: 0;
            vertical-align: middle;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    i.arrow {
        top: 39px;
    }
    .allow {
		height:14px;
    }
    .more {
        position: absolute;
        top: 24px;
        right: 33px;
        line-height: 30px;
    }
    .announcement {
        position: relative;
        font-size:12px;
        font-weight: 300;
        color:#777893;
        line-height:30px;
        padding: 0 18px;
        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 18px;
            right: 18px;
            height: 1px;
            z-index: 1;
            background: linear-gradient(top, rgba(0, 0, 0, 0.05), transparent 50%, transparent);
        }
    }
}

</style>



// WEBPACK FOOTER //
// ShopBrief.vue